<template>
  <div class="htDetails full-height">
    <ld-header>
      订单信息填写
    </ld-header>
    <div class="wrapper">
      <mescroll-vue
        ref="mescroll"
        :down="{use:false}"
      >
        <van-cell>
          <van-row
            gutter="16"
            type="flex"
            align="center"
          >
            <van-col span="8">
              <van-image
                :src="searchInfo.images[0]"
                radius="8"
                lazy-load
                show-error
                show-loading
                style="min-width:80px;min-height:80px;"
              >
                <template v-slot:loading>
                  <van-loading
                    type="spinner"
                    size="20"
                  />
                </template>
                <template v-slot:error>
                  加载失败
                </template>
              </van-image>
            </van-col>
            <van-col span="16">
              <div class="font-md">
                {{ searchInfo.loungeNameCn }}
              </div>
              <!-- <van-rate
              v-model="value"
              allow-half
              readonly
              :size="14"
              color="#ffd21e"
              void-icon="star"
              void-color="#eee"
            />
            <span>  2.5 </span> -->
              <div class="gray font12">
                {{ searchInfo.terminal }}航站楼 {{ searchInfo.securityCheck==1?'安检后':'安检前' }}
              </div>
              <div class="font12 money-color">
                &yen;{{ searchInfo.salePrice +searchInfo.serviceFee }}
              </div>
            </van-col>
          </van-row>
        </van-cell>
        <van-cell icon="location-o">
          <div class="font12">
            <div>
              {{ searchInfo.leaveType==1?'国内出发':'国际出发' }} <span v-show="searchInfo.terminal">{{ searchInfo.terminal }}航站楼，</span>
              <span v-show="searchInfo.nearBoarding "> 临近{{ searchInfo.nearBoarding }}登机口</span> ，{{ searchInfo.loungeAddress }} 
            </div>
            <div class="gray">
              {{ searchInfo.cityName }}  {{ params.serverAirportName }}
            </div>
          </div>
        </van-cell>
        
        <!--  -->
        <div class="box">
          <van-cell title="购买人次">
            <van-stepper v-model="personTime" />
          </van-cell>
        </div>
        <!--  -->

        <trip-type
          is-switch
          :switch-title="tripType==1?'本次预订为因公预订':'本次预订为因私预订'"
          class="box"
        />

        <!-- 差旅信息 -->
        <travel-info
          class="box"
          v-show="tripType==1"
          ref="travelinfo"
          @selected="getTavelInfo"
          element=".fastCheckConfirm"
        />

        <!-- 联系信息 -->
        <van-field
          :label="$t('D022','联系信息')"
          :readonly="true"
          @click="$refs['linker'].toggle()"
        >
          <div slot="input">
            {{ linker.linkMan }} ({{ linker.linkTel || linker.linkMobile }})
                
            <div class="font12 gray">
              {{ $t('D020','邮箱') }} ({{ linker.linkEmail }})
            </div>
          </div>
        </van-field>
      </mescroll-vue>
    </div>
    <!--  -->
    <ld-tabbar
      ref="tabbar"
      class="bg-white shadow"
    >
      <van-row
        class="full-width"
        type="flex"
        align="center"
        gutter="8"
        justify="center"
      >
        <van-col span="14">
          应付&nbsp;
          <span class="money-color font16">&yen;{{ (searchInfo.salePrice+searchInfo.serviceFee ||0)* personTime }}</span>
        </van-col>
        <van-col
          span="8"
        >
          <ld-button
            main
            size="md"
            @click="book"
          >
            提交订单
          </ld-button>
        </van-col>
      </van-row>
    </ld-tabbar>

    <!-- 编辑联系人 -->
    <ld-edit-linker
      ref="linker"
      :data="linker"
      @selected="getLinker"
    />
    <!--  -->
  </div>
</template>

<script>
import { Stepper, Cell, CellGroup,Rate , Image as VanImage,loading,Field} from 'vant'
import { mapGetters } from 'vuex'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import travelInfo from 'Components/travelInfo'
import { getName, getIdType, getIdNumber } from 'Utils/publicFun'
import ldEditLinker from 'Components/ldEditLinker'
import tripType from 'Common/tripType'

export default {
  name: 'HtDetails',
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Rate.name]:Rate,
    [Cell.name]: Cell,
    [Rate.name]: Rate,
    [VanImage.name]: VanImage,
    [loading.name]: loading,
    [Stepper.name]: Stepper,
    [Field.name]: Field,
    ldTabbar,
    MescrollVue: () => import('mescroll.js/mescroll.vue'),
    ldButton: () => import('Common/ldButton'),
    travelInfo,
    ldEditLinker,
    tripType
  },
  data() {
    return {
      personTime:1,
      priceList: [],
      isLoading: false,
      loading: false,
      path: '',
      linker:{}
    }
  },
  computed: {
    ...mapGetters({
      tripType:'tripType',
      userInfo:'userInfo',
      searchInfo: 'restRoom/searchInfo',
      travelerList: 'restRoom/travelerList',
      params: 'restRoom/params',
      sysType:'sysType'
    }),
  },
  created () {
    this.linker={
      linkEmail:this.userInfo.empInfo.email,
      linkMan:this.userInfo.empInfo.empName,
      linkTel:this.userInfo.empInfo.phoneNumber
    }
  },
  methods: {
    getTavelInfo(info) {// 获取差旅信息
      let obj={
        'projectId': '',
        'projectCode': '',
        'projectName': '',
        'ccsqdId': '',
        'ccsqdNo': '',
        'routeId': '',
        'costCenterId': '',
        'costCenterCode': '',
        'costCenterName': '',
        'violateitemCode': '',
        'violateitem': '',
        'reasonCode': '',
        'reasonDesc': '',
        'corpId': '',
        'corpCode': '',
        'corpName': '',
        'tripType': '',
        'ccsqdRemark': '',
        'subjectCode': '',
        'ifSameOrder': ''
      }
      for(let k in obj){
        if(info[k]){
          obj[k]=info[k]
        }
      }
      this.travelInfo=obj
    },
    book(){
      // if(this.travelerList.length==0){
      // 	this.$toast('请选择乘机人！')
      // 	return
      // }
      if(!this.linker.linkTel){
        this.$toast('联系人手机号不能为空！')
        return
      }
      if(this.tripType==1){
        let bl=this.$refs.travelinfo.result()//判断差旅信息是否填写完整 
        if(bl==false){
          return
        }
      }
      let psgList = this.travelerList.map((item) => {
        return {
          psgName: getName(item),
          psgType: item.psgType||'1',
          cardType: getIdType(item),//证件类型
          idNo: getIdNumber(item),//证件号码
          phoneNumber: item.phoneNumber,
          empId: item.conempId || item.empId
        }
      })
      this.$api['airService/bookOrder']({
        orderType:'11028',
        productId:this.searchInfo.id,
        seatType:this.params.seatType,
        personTime :this.personTime,//人次 
        flightDate:this.params.departDate,
        flightNo :this.searchInfo.flightNo,
        deptCity  :this.searchInfo.departAirport,
        deptCityName:this.searchInfo.departCityName,
        arrCity :this.searchInfo.arriveAirport,
        arrCityName :this.searchInfo.arriveCityName,
        'psgBeanList': psgList,
        serverTime:'',
        serverType :'',
        serverAirportCode:this.params.serverAirportCode,
        serverAirportName:this.params.serverAirportName,
        linkman :this.linker.linkMan,
        linkMobile:this.linker.linkTel,
        linkEmail:this.linker.linkEmail,
        tripType:this.tripType,
        'travelInfo' :this.travelInfo,
        orderFrom :this.sysType,
        relateOrder :this.params.relateOrder,//关联单号
      }).then(res=>{
        let cache=res.data||{}
        this.$router.push({path:'/restRoom/order',query: { orderId:cache.orderId}})
      })
    },
    getLinker(info) {//修改联系人回调
      this.linker = {}
      this.linker = info
    },
  },
  watch: {},
}

</script>
<style lang="less" scoped >
    .box{
        padding-bottom: 5px;
    }
    .htDetails {
        height: 100vh;
        overflow: hidden;
    }
    .wrapper {
        height: calc(100vh - 96px);
        overflow: hidden;
    }
</style>